<template>
  <v-layout class="justify-space-between">
    <!-- run events -->
    <v-flex xs12 sm6 md3>
      <CoreIconCardStat 
        :statvalue="str(stats.totalRunEvents)"
        title="Total RUN intervals"
        subtitle="Total number run intervals in date range."
        icon="event">
      </CoreIconCardStat>
    </v-flex>
    <!-- output performance -->
    <v-flex xs12 sm6 md3>
      <CoreIconCardStat 
        :statvalue="percent(stats.totalActualOutput, stats.totalTargetOutput)"
        title="Output Performance"
        subtitle="Achieved output (actual / target)."
        icon="show_chart" 
        statcolor="primary">
      </CoreIconCardStat>
    </v-flex>
    <!-- value performance -->
    <v-flex xs12 sm6 md3>
      <CoreIconCardStat 
        :statvalue="percent(stats.totalActualValue, stats.totalTargetValue)"
        title="Value Performance"
        subtitle="Achieved value (actual / target)."
        icon="show_chart" 
        statcolor="#BB2525">
      </CoreIconCardStat>
    </v-flex>
    <!-- total value -->
    <v-flex xs12 sm6 md3>
      <CoreIconCardStat 
        :statvalue="currency(stats.totalActualValue)"
        title="Total Value"
        subtitle="All run intervals total value."
        icon="attach_money" 
        statcolor="#BB2525">
      </CoreIconCardStat>
    </v-flex>

  </v-layout>
</template>

<script>
export default {
  props: {
    intervals: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      stats: {
        totalRunEvents: 0,
        totalTargetOutput: 0.0,
        totalActualOutput: 0.0,
        totalTargetValue: 0.0,
        totalActualValue: 0.0
      }
    }
  },
  created() {
    this.tally()
  },
  methods: {
    tally() {
      this.stats.totalRunEvents = 0
      this.stats.totalTargetOutput = 0.0
      this.stats.totalActualOutput = 0.0
      this.stats.totalTargetValue = 0.0
      this.stats.totalActualValue = 0.0
      for (var i = 0; i < this.intervals.length; i++) {
        let interval = this.intervals[i]
        if (interval.guidance === 'DID_RUN') {
          this.stats.totalRunEvents++
          this.stats.totalTargetOutput += interval.optimal_power_output_kw
          this.stats.totalActualOutput += interval.actual_power_output_kw
          this.stats.totalTargetValue += interval.value_at_stake
          this.stats.totalActualValue += interval.actual_value_at_stake
        }
      }
    },
    percent(top, bottom) {
      if (bottom > 0) {
        return parseInt((top / bottom) * 100.0) + '%'
      }
      return ' - '
    },
    currency(val) {
      if (val != null) {
        var formatter = new Intl.NumberFormat('en-US', {
          style: 'decimal',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })
        return '$' + formatter.format(val)
      }
      return '-'
    },
    str(val) {
      return '' + val
    }
  }
}
</script>
